export function createElementsFromHtml(html) {
    const $div = document.createElement('div');
    $div.innerHTML = html;

    return $div.children;
}